import { render, staticRenderFns } from "./indexWallet.vue?vue&type=template&id=e9907234"
import script from "./indexWallet.vue?vue&type=script&lang=js"
export * from "./indexWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports